import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ugpvmbmfcaqdtphovcfm.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVncHZtYm1mY2FxZHRwaG92Y2ZtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDUzNTAwNDYsImV4cCI6MjA2MDkyNjA0Nn0.2QBGCf2dW42Hek1zNDzX9q8xeanPE4tOIvzBv29OfbI';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
